import React, { useCallback, useState } from 'react';
import { useDropzone } from 'react-dropzone';
import { Upload, X, Image } from 'lucide-react';

export default function ImageUpload({ value, onChange, label = 'Image', progress }) {
  const [preview, setPreview] = useState(value || null);

  const onDrop = useCallback(files => {
    const file = files[0];
    if (!file) return;
    setPreview(URL.createObjectURL(file));
    onChange(file);
  }, [onChange]);

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: { 'image/*': ['.jpg', '.jpeg', '.png', '.webp'] },
    maxFiles: 1,
  });

  const clear = e => {
    e.stopPropagation();
    setPreview(null);
    onChange(null);
  };

  return (
    <div>
      <label className="block text-sm text-[#B0BEC5] mb-2">{label}</label>
      <div
        {...getRootProps()}
        className={`relative border-2 border-dashed rounded-xl overflow-hidden cursor-pointer
          transition-all ${isDragActive ? 'border-[#2D5BE3] bg-[#2D5BE3]/10' : 'border-[#1E2D45] hover:border-[#2D5BE3]/50'}`}
        style={{ minHeight: 140 }}
      >
        <input {...getInputProps()} />
        {preview ? (
          <>
            <img src={preview} alt="preview" className="w-full h-36 object-cover" />
            <button
              onClick={clear}
              className="absolute top-2 right-2 w-7 h-7 bg-red-500/80 rounded-full
                flex items-center justify-center text-white hover:bg-red-500 transition-colors"
            >
              <X size={14} />
            </button>
            {progress !== undefined && progress < 100 && (
              <div className="absolute bottom-0 left-0 right-0 h-1 bg-[#1E2D45]">
                <div
                  className="h-full bg-[#2D5BE3] transition-all"
                  style={{ width: `${progress}%` }}
                />
              </div>
            )}
          </>
        ) : (
          <div className="flex flex-col items-center justify-center py-8 text-[#546E7A]">
            <div className="w-12 h-12 rounded-xl bg-[#1E2D45] flex items-center justify-center mb-3">
              {isDragActive ? <Upload size={22} className="text-[#2D5BE3]" /> : <Image size={22} />}
            </div>
            <p className="text-sm font-medium">
              {isDragActive ? 'Drop image here' : 'Click or drag image'}
            </p>
            <p className="text-xs mt-1">JPG, PNG, WebP</p>
          </div>
        )}
      </div>
      {value && !preview && (
        <div className="mt-2 flex items-center gap-2">
          <img src={value} alt="" className="w-10 h-10 rounded-lg object-cover" />
          <span className="text-xs text-[#546E7A] truncate flex-1">{value}</span>
          <button onClick={() => onChange(null)} className="text-red-400 hover:text-red-300">
            <X size={14} />
          </button>
        </div>
      )}
    </div>
  );
}
